<template>
  <div class="course-item-box">
     <img alt class="course-item-icon" v-if="detailData.typeId>15"   src="@/assets/img/h5/courseDetail/zhangjie.png" />
      <img alt class="course-item-icon" v-if="detailData.typeId==1 ||  detailData.typeId==5
      ||  detailData.typeId==6||  detailData.typeId==7||  detailData.typeId==15
        "  src="@/assets/img/h5/courseDetail/zhenti.png" />
    <img alt class="course-item-icon" v-if="detailData.typeId==2 ||  detailData.typeId==8 ||  detailData.typeId==9||  detailData.typeId==10"  src="@/assets/img/h5/courseDetail/zhangjie.png" />
    <img alt class="course-item-icon"  v-if="detailData.typeId==3 ||  detailData.typeId==11 ||    detailData.typeId==12 ||  detailData.typeId==13" src="@/assets/img/h5/courseDetail/moni.png" />
    <img alt class="course-item-icon"  v-if="detailData.typeId==4 ||  detailData.typeId==23" src="@/assets/img/h5/courseDetail/mijuan.png" />

    <div class="course-item-info van-hairline--bottom">
      <div class="info-left">
        <div
          class="info-left-top van-ellipsis"
          v-if="detailData.examinationName != null "
        >{{detailData.examinationName}}</div>
        <div
          class="info-left-top van-ellipsis"
          v-if="type == 3 ||type == 5 "
        >{{detailData.datumName}}</div>
        <div
          class="info-left-bottom"
          v-if="type == 1"
        >{{ detailData.customerExaminationTestLogEntity && detailData.customerExaminationTestLogEntity .isCommit == 2 ? detailData.customerExaminationTestLogEntity.testedCount+'/'+detailData.questionCount : '共'+detailData.questionCount+'题'}}</div>
        <div
          class="info-left-bottom"
          v-if="type == 2 && !isRecommend"
        >{{ detailData.wrongCount - detailData.questionCount > 0 ? '共'+detailData.questionCount+'错题' : '共'+ detailData.wrongCount +'错题' }}</div>
        <div
          class="info-left-bottom"
          v-if="type == 3 && !isRecommend"
        >{{ '共收藏'+detailData.wrongCount+'道题'}}</div>
      </div>
      <div class="info-right">
        <div>
          <div class="info-right-top" v-if="  type == 5 && !isRecommend">{{'下载查看'}}</div>
          <div class="info-right-top" v-if="  type == 2 && !isRecommend">{{'查看错题'}}</div>
          <div class="info-right-top" v-if="  type == 3 && !isRecommend">{{'查看收藏'}}</div>
          <div
            class="info-right-top"
            v-if="detailData.customerExaminationTestLogEntity == null &&  type == 1 && !isRecommend"
          >{{'开始答题'}}</div>
          <div class="info-right-top" v-if=" isRecommend">{{'开通课程'}}</div>
          <div
            class="info-right-top"
            v-if="detailData.customerExaminationTestLogEntity != null &&  type == 1 && !isRecommend"
          >{{detailData.customerExaminationTestLogEntity.isCommit ===1 ? '重新答题':'继续答题'}}</div>
        </div>
        <van-icon class="info-arrow" name="arrow" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseItemDetail",
  // 根据type传入显示固定的文本和对应数据   type  2:错题   3:收藏 5:资料展示
  props: ['detailData', 'type', 'isRecommend'],
  data () {
    return {
    };
  },
  components: {

  },
  mounted () {
       console.log(this.detailData)
  },
  methods: {

  },
}
</script>
<style lang="less" scoped>
.course-item-icon {
  width: 32px;
  height: 37px;
  margin: 20px 0;
}
.course-item-box {
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
  .course-item-info {
    margin-left: 18px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 20px 0;
    .info-left {
      .info-left-top {
        width: 200px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
      }
      .info-left-bottom {
        .info-right > .info-right-bottom;
      }
    }
    .info-right {
      display: flex;
      align-items: center;
      .info-arrow {
        margin-left: 9px;
        height: 14px;
        width: 14px;
        color: #d8d8d8;
      }
      .info-right-top,
      .info-right-bottom {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(161, 161, 161, 1);
        line-height: 12px;
      }
      .info-right-bottom {
        margin-top: 12px;
      }
    }
  }
}
</style>